export class LemonaidProjektitUriService {
  annaKirjanpitoLemonaidProjektitCollection(asiakasAvain: string) {
    return 'customers/' + asiakasAvain + '/projektit/'
  }

  annaKirjanpitoLemonaidProjektiAvaimellaCollection(asiakasAvain: string, projektiAvain: string) {
    return 'customers/' + asiakasAvain + '/projektit/' + projektiAvain
  }
}
